import { createSelector } from 'reselect';
import { isEmpty } from 'lodash';

const influencerItemSelector = item => item;

const selectedProductsFiltersSelector = createSelector(
  influencerItemSelector,
  item => (!isEmpty(item) && item.page.topTen.selectedProductsFilters
    ? item.page.topTen.selectedProductsFilters
    : []),
);

export const topTenSelectedProductsFilterSelector = createSelector(
  selectedProductsFiltersSelector,
  selectedProductsFilters => (selectedProductsFilters),
);

export default {
  topTenSelectedProductsFilterSelector,
};
